import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'redux-form'
import styles from './_selectField.css'
import classnames from 'classnames'
import Svg from 'components/util/Svg'
import fieldProps from '../fieldProps'
import FieldLabel from '../FieldLabel'
import FieldError from '../FieldError'

export const SelectField = (props) => {
  const {
    input,
    required,
    name,
    labelComponent,
    type,
    slim,
    errorComponent,
    options,
    placeholder,
    disabled,
    className,
    forceError,
    onChange,
    bold,
    hideError,
    meta: {
      touched,
      error,
    },
  } = props

  const showError = Boolean((touched && error) || forceError)

  return (
    <label
      htmlFor={name}
      className={classnames(styles.container, className, {
        [styles.disabled]: disabled,
        [styles.selected]: Boolean(input.value),
        [styles.slim]: slim,
      })}>
      <FieldLabel labelComponent={labelComponent} required={required} bold={bold} />
      <div className={styles.inputContainer}>
        <select
          {...input}
          onChange={(e) => {
            // Call redux-form onChange first to update the state
            input.onChange(e.target.value)

            // And then call a custom onChange that was passed from props
            onChange(e.target.value)
          }}
          id={name}
          type={type}
          disabled={disabled}
          placeholder={placeholder}
          className={classnames(styles.input, { [styles.error]: showError })}
        >
          {placeholder ?
            <option value=''>{placeholder}</option>
          : null}
          {options.map(({ label: optionLabel, value }, i) => (
            <option key={optionLabel + i} value={value}>{optionLabel}</option>
          ))}
        </select>
        <Svg name='select_down' className={styles.arrow} />
      </div>

      {!hideError ?
        <FieldError
          showError={showError}
          errorMessage={error}
          errorComponent={errorComponent}
        />
      : null}
    </label>
  )
}

SelectField.propTypes = fieldProps

export const renderField = (field) => (
  <SelectField {...field} />
)

export const FieldWrapper = ({ ...props }) => (
  <Field {...props} component={renderField} />
)

FieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  error: PropTypes.node,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  hideError: PropTypes.bool,
}

FieldWrapper.defaultProps = {
  onChange: function () {},
}

export default FieldWrapper



// WEBPACK FOOTER //
// ./src/components/forms/SelectField/SelectField.jsx